export default {
	namespaced: true,

	state: {
		upsellRoutes: [],
		purchasedUpsells: {},
		glpShippingData: null,
	},

	mutations: {
		setUpsellRoutes(state, order) {
			state.upsellRoutes = order
		},

		setPurchasedUpsell(state, purchasedUpsell) {
			this._vm.$set(state.purchasedUpsells, purchasedUpsell, true)
		},

		setGlpShippingData(state, data) {
			state.glpShippingData = data
		},
	},

	getters: {
		getNextUpsellRouteName: (state) => (currentRouteName, upgradeRouteName) => {
			const upgradeOrUpdateRouteName = upgradeRouteName || 'update-profile'

			if (state.upsellRoutes.length === 0) {
				return upgradeOrUpdateRouteName
			}

			const currentRouteIndex = state.upsellRoutes.indexOf(currentRouteName)

			if (currentRouteIndex === -1) {
				return state.upsellRoutes[0]
			} else if (currentRouteIndex < state.upsellRoutes.length - 1) {
				return state.upsellRoutes[currentRouteIndex + 1]
			}

			return upgradeOrUpdateRouteName
		},

		getGlpShippingData: (state) => state.glpShippingData,
	},
}
